export default __webpack_public_path__ + "static/media/mobile_dev_img.e216816c.svg";